import useApiMutation from 'shared/hooks/use-api-mutation';
import {BillingProps} from '../types';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import billingsKeys from '../util/billings-keys';

const usePayBilling = (billingId: string) => {
  const {setData} = useQueryHelpers();
  const {update} = useInfiniteQueryHelpers();

  const onSuccess = (data: BillingProps) => {
    setData(billingsKeys.details(billingId), data);
    update(billingsKeys.list(), data);
  };

  return useApiMutation<{paid: boolean}>({
    url: `/billing/${billingId}/paid`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar fatura',
    successTitle: 'Alterar fatura',
    successMessage: 'Fatura alterada com sucesso!',
    onSuccess,
  });
};

export default usePayBilling;
